<template>
  <div>
    <h3 class="rs-data-title">{{tituloTabela}}</h3>
    <v-data-table
      dense
      hide-actions
      class="elevation-1"
      :headers="headers"
      :items="boletos"
      :loading="loadingActive"
      item-key="bug_id"
      no-results-text="Nada foi encontrado."
      :no-data-text="noDataText"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            <md-icon class="rs-priority-icon" v-if="props.item.BOLSITUACAO == 'A'" style="color: #ffcc66;">circle</md-icon>
            <md-icon class="rs-priority-icon" v-else-if="props.item.BOLSITUACAO == 'C'" style="color: #ff6666;">cancel</md-icon>
            <md-icon class="rs-priority-icon" v-else style="color: #66cc66;">circle</md-icon>
            {{props.item.BOLNUMERO}}
          </td>
          <td>{{ formatAcRealRequisicao(props.item.BOLVENCIMENTO) }}</td>
          <td>{{ props.item.CLINOME || "---" }}</td>
          <td>{{ props.item.CLINOMEUSUAL || "---" }}</td>
          <td>            
            <md-icon class="rs-priority-icon" v-if="(props.item.BOLSITUACAOENVIO == 2)" style="color: #66aaff;">done_all</md-icon>
            <md-icon class="rs-priority-icon" v-else-if="props.item.BOLSITUACAOENVIO == 1" style="color: #66aaff;">check</md-icon>
            <md-icon class="rs-priority-icon" v-else-if="(props.item.BOLSITUACAOENVIO == 0 && props.item.APTORECEBER == 1)" style="color: #cccccc;">check</md-icon>
          </td>
          <td class="text-xs-left">
            <v-btn flat icon small color="#6699cc"
                v-clipboard="'https://financeiro.realtec.com.br/' + props.item.BOLURL"
                @click="msg = 'Copiado com sucesso.'">
              <v-icon>link</v-icon>
            </v-btn>            
          </td>          
          <td class="text-xs-left">
            <v-btn v-if="props.item.BOLURLNF" flat icon small color="#6699cc"
                v-clipboard="'https://financeiro.realtec.com.br/' + props.item.BOLURLNF"
                @click="msg = 'Copiado com sucesso.'">
              <v-icon>link</v-icon>
            </v-btn>            
          </td>                    
        </tr>
      </template>

      <template v-slot:expand="props">
      </template>
    </v-data-table>     
  </div>
</template>
<script>

import moment from "moment";

export default {
  props: ["boletos", "loadingActive", "noDataText", "tituloTabela"],
  data() {
      return {
        bugs: [],
        headers: [
          {
            text: "Número",
            value: "BOLNUMERO"
          },
          {
            text: "Vencimento",
            value: "BOLVENCIMENTO"
          },
          {
            text: "Razão Social",
            value: "CLINOME"
          },
          {
            text: "Nome Usual",
            value: "CLINOMEUSUAL"
          },
          {
            text: "Envio",
            value: "BOLSITUACAOENVIO"
          },
          {
            text: "Boleto",
            value: "BOLURL"
          },
          {
            text: "NFS",
            value: "BOLURLNF"
          }
        ]
      }
  },
  components:{
  },
  created() {
    
  },
  methods: {
    formatAcRealRequisicao(_acRealRequisicao) {
      return moment(_acRealRequisicao).format("DD/MM/YYYY");
    },    
  }  
};
</script>
<style scoped>
.subtitle-2 {
  min-height: 30px;
}
.overlayy {
  z-index: 10;
  background: rgba(0, 0, 0, 0.39);
  position: absolute;
  width: 100%;
  height: 99%;
  top: 0;
  border-radius: 5px;
  left: 0;
}
li {
  min-height: 58px;
}

span,
div,
table,
td,
tr,
th {
  transition: all 0.3s ease !important;
}

/*.md-theme-default a:not(.md-button) {
  color: #2b5577 !important;
}*/

.md-theme-default a:hover {
  color: #00aaff !important;
  text-decoration: underline !important;
}

table.v-table tbody td, table.v-table tbody th{
  height: 25px;
}

.rs-data-title{
  display: flex;
  justify-content: center;
}

.rs-priority-icon{
  margin-right: 10px;
  font-size: 20px !important;
}

</style>